import script from "./AppButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=d51da890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d51da890"]])

export default __exports__